import { render } from "./PageNotFound.vue?vue&type=template&id=5f2345db"
import script from "./PageNotFound.vue?vue&type=script&lang=js"
export * from "./PageNotFound.vue?vue&type=script&lang=js"

import "./PageNotFound.vue?vue&type=style&index=0&id=5f2345db&lang=css"

import exportComponent from "/home/adrien/perso/Projets/new-portfolio/vuejs-tailwind-portfolio/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__